import React, { useState } from "react";
import "./BookingForm.css";

const WHATSAPP_NUMBER = "355686328765";

export default function BookingForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    selectedTour: "Free Walking Tour",
    preferredDate: "",
    preferredHour: "12",
    preferredMinute: "00",
    participants: "1",
    notes: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formattedHour = formData.preferredHour.padStart(2, "0");
    const formattedMinute = formData.preferredMinute.padStart(2, "0");

    const message =
    `Booking Request\n\n` +
    `Full Name: ${formData.fullName}\n` +
    `Email: ${formData.email}\n` +
    `Tour: ${formData.selectedTour}\n` +
    `Participants: ${formData.participants}\n` +
    `Date: ${formData.preferredDate}\n` +
    `Time: ${formattedHour}:${formattedMinute}\n` +
    `Notes: ${formData.notes || "None"}`;

    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <section className="booking-section compact">
      <h2>Book Your Free Walking Tour</h2>
      <p className="booking-intro">
        Fill in your details and send a WhatsApp booking request instantly.
      </p>

      <form className="booking-form" onSubmit={handleSubmit}>
        
        {/* NAME + EMAIL */}
        <div className="form-row">
          <label>
            Full Name
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Email
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>
        </div>

        {/* SELECTED TOUR + PARTICIPANTS */}
        <div className="form-row">
          <label>
            Selected Tour
            <input
              type="text"
              name="selectedTour"
              value={formData.selectedTour}
              readOnly
            />
          </label>

          <label>
            Participants
            <input
              type="number"
              name="participants"
              min="1"
              value={formData.participants}
              onChange={handleChange}
              required
            />
          </label>
        </div>

        {/* DATE + TIME */}
        <div className="form-row">
          <label>
            Date
            <input
              type="date"
              name="preferredDate"
              value={formData.preferredDate}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Time
            <div className="time-picker">
              <input
                type="number"
                name="preferredHour"
                min="0"
                max="23"
                value={formData.preferredHour}
                onChange={handleChange}
                required
              />
              <span>:</span>
              <input
                type="number"
                name="preferredMinute"
                min="0"
                max="59"
                value={formData.preferredMinute}
                onChange={handleChange}
                required
              />
            </div>
          </label>
        </div>

        {/* NOTES */}
        <label>
          Notes (Optional)
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
          />
        </label>

        <button type="submit" className="send-button">
  <span className="whatsapp-icon">
    <svg viewBox="0 0 24 24" width="20" height="20">
      <path
        fill="currentColor"
        d="M20.52 3.48A11.86 11.86 0 0012.06 0C5.4 0 .02 5.38.02 12.04c0 2.12.55 4.18 1.6 6L0 24l6.13-1.6a11.98 11.98 0 005.93 1.52h.01c6.66 0 12.04-5.38 12.04-12.04 0-3.22-1.26-6.24-3.59-8.4zM12.07 21.7c-1.82 0-3.6-.5-5.14-1.46l-.37-.22-3.64.95.97-3.55-.24-.38a9.64 9.64 0 01-1.48-5.06c0-5.33 4.34-9.67 9.67-9.67 2.58 0 5 1 6.83 2.84a9.6 9.6 0 012.83 6.83c0 5.33-4.34 9.67-9.67 9.67zm5.29-7.26c-.29-.15-1.7-.84-1.97-.94-.27-.1-.46-.15-.65.15-.2.29-.76.94-.93 1.13-.17.2-.34.22-.63.07-.29-.15-1.23-.45-2.34-1.44-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.5.15-.17.2-.29.3-.49.1-.2.05-.37-.02-.52-.07-.15-.65-1.62-.9-2.22-.24-.58-.48-.5-.65-.5h-.55c-.2 0-.52.07-.79.37-.27.29-1.04 1.02-1.04 2.49s1.07 2.88 1.22 3.08c.15.2 2.1 3.21 5.09 4.5.71.31 1.26.5 1.69.64.71.23 1.35.2 1.86.12.57-.08 1.7-.7 1.94-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.2-.55-.35z"
      />
    </svg>
  </span>

  Send via WhatsApp
</button>
      </form>
    </section>
  );
}